import React, { useState, useEffect } from "react"
import { useIntl } from "react-intl"
import formatCurrency from "../../helpers/currencyHelper"
import { AlertError, AlertLoading } from '../../helpers/AlertHelper'

import InvoicesService from "../../services/InvoicesService"


import BarChart from "../../components/charts/BarChart"

const InvoicesReports = ({ onChangeDataset, yearFrom = '', yearTo = '' }) => {
    const intl = useIntl()
    
    const [invoicesDataset, setInvoicesDataset] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(null)

    // Fetch invoices dataset
    const fetchInvoicesDataset = async () => {
        try {
            const response = await InvoicesService.getInvoicesDataset({ yearFrom, yearTo })
            const { labels, datasets } = response.data.dataset

            // Construcción del dataset directamente al obtener los datos
            const formattedDataset = {
                labels,
                datasets: [
                    {
                        label: intl.formatMessage({ id: "invoicesTotalAmount", defaultMessage: "Total amount" }),
                        data: datasets[0].data,
                        yAxisID: "y",
                        borderColor: "rgb(53, 162, 235)",
                        backgroundColor: "rgba(53, 162, 235, 0.5)",
                        datalabels: {
                            anchor: 'end',
                            align: 'end',
                            color: '#333',
                            rotation: -45,
                            font: {
                                weight: 'bold',
                                size: 12
                            },
                            formatter: value => formatCurrency(value),
                        },
                    },
                ],
            }

            setInvoicesDataset(formattedDataset)
            onChangeDataset({
                ...formattedDataset,
                datasets: [formattedDataset.datasets[0]],
                totalAmountsSum: response.data.dataset.totalAmountsSum,
                totalInvoicesSum: response.data.dataset.totalInvoicesSum
            })
            setIsLoaded(true)
        } catch (err) {
            setIsLoaded(false)
            setError(err)
        }
    }

    // Re-fetch data on page/perPage change
    useEffect(() => {
        fetchInvoicesDataset()
    }, [yearFrom, yearTo])

    return (
        <>
            {error && <AlertError error={error} />}
            {!isLoaded && <AlertLoading isLoaded={isLoaded} />}
            {isLoaded && (
                <BarChart
                    //title={intl.formatMessage({ id: "navInvoices", defaultMessage: "Customers Invoices" })}
                    data={invoicesDataset}
                />
            )}
        </>
    )
}

export default InvoicesReports